import Link from 'next/link';
import { memo } from 'react';
import styles from './FooterContent.module.css';

export const FooterContent = memo(
  ({
    navigation,
    copyright,
  }: {
    navigation: Array<{ url: string; label: string; order: number }>;
    copyright: string;
  }) => {
    return (
      <>
        <p className={styles.copyright}>{copyright}</p>
        <nav>
          <ul className={styles.list}>
            {navigation
              .sort((a, b) => a.order - b.order)
              .map((item, index) => (
                <li key={index} className={styles.link}>
                  <Link href={item.url} target="_blank">
                    {item.label}
                  </Link>
                </li>
              ))}
          </ul>
        </nav>
      </>
    );
  },
);
